import { Check, CloseRounded } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { enableUser } from '../../../../../../redux/actions/users'
import { CancelButton, SaveButton } from '../../../../../shared/components/inputs'
import { StyledDialog } from '../../../../../shared/styles/StyledDialog'
import { isAdmin } from '../../../utils/RolesHelper'

type EnableUserProps = {
  authUser: any
  userProfileSelected: any
}

function EnableUser({ authUser, userProfileSelected }: EnableUserProps) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const [open, setOpen] = useState(false)

  const handleClickEnable = () => {
    setOpen(!open)
  }

  const handleSubmitEnable = () => {
    dispatch(enableUser(userProfileSelected.id))
    setOpen(!open)
  }

  return (
    <>
      {isAdmin(authUser.role_id) && userProfileSelected.status === 0 && (
        <Grid item>
          <Button onClick={handleClickEnable} variant="contained" color="primary" startIcon={<Check />}>
            {t('enable')} {t('user')}
          </Button>
        </Grid>
      )}

      <StyledDialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              {t('enable')} {t('user')}
            </Typography>
            <Button onClick={() => setOpen(false)} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>
        <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid item xs={12}>
              <Typography>{t('admin.people.enable-user-text')}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={() => setOpen(false)} variant="contained" color="secondary">
            {t('cancel')}
          </CancelButton>
          <SaveButton id="btn-handlelogin" endIcon={<Check />} onClick={() => handleSubmitEnable()}>
            {t('allow')}
          </SaveButton>
        </DialogActions>
      </StyledDialog>
    </>
  )
}

export default EnableUser
